import { useCallback, useEffect, useState } from 'react';
import {
  acquire,
  getOrFetch,
  peek,
  release,
  subscribe,
} from '../services/auditImageCache';

/**
 * Load an audit image immediately (no Intersection Observer).
 * Use in modals, tooltips, and timelines — not scroll grids.
 */
export function useEagerAuditImage(auditId, enabled = true) {
  const [, tick] = useState(0);
  const bump = useCallback(() => tick((n) => n + 1), []);

  useEffect(() => {
    if (!auditId || !enabled) return undefined;
    acquire(auditId);
    const unsubscribe = subscribe(auditId, bump);
    getOrFetch(auditId).finally(bump);
    return () => {
      unsubscribe();
      release(auditId);
    };
  }, [auditId, enabled, bump]);

  const url = auditId && enabled ? peek(auditId) : undefined;
  return { url };
}

export default useEagerAuditImage;
